import React from "react";
import AllFeedbacks from "../../components/Purchases/AllPurchases";

function Feedbacks() {
  return (
    <div>
      <AllFeedbacks />
    </div>
  );
}

export default Feedbacks;
